import { BrandOrder } from '@/types/services';

export const getSelectedBrandsWithOrderIds = (selectedBrands: BrandOrder[]) => {
  return selectedBrands
    .filter(b => b.name !== 'ОККО' && b.displayOrder !== null)
    .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0))
    .map(b => b.id);
};

export const getSelectedBrandsWithoutOrderIds = (selectedBrands: BrandOrder[]) => {
  return selectedBrands.filter(b => b.name !== 'ОККО' && b.displayOrder === null).map(b => b.id);
};

export const getOrderedBrands = (activeBrandsOrder: BrandOrder[]) => {
  const selectedBrands = activeBrandsOrder.filter(b => b.isSelected);
  const okko = selectedBrands.find(b => b.name === 'ОККО');

  const withOrderIds = getSelectedBrandsWithOrderIds(selectedBrands);
  const withoutOrderIds = getSelectedBrandsWithoutOrderIds(selectedBrands);
  const orderedBrands = [];
  if (okko) orderedBrands.push(okko.id);
  orderedBrands.push(...withOrderIds, ...withoutOrderIds);
  return orderedBrands;
};

export const getBrandUpdates = (activeBrandsOrder: BrandOrder[], visibleBrands: Set<number>, localOrder: number[]) => {
  return activeBrandsOrder.map(brand => {
    const isCurrentlySelected = visibleBrands.has(brand.id);
    const orderIndex = localOrder.indexOf(brand.id);

    return {
      brandId: brand.id,
      isSelected: isCurrentlySelected,
      displayOrder: isCurrentlySelected && orderIndex >= 0 ? orderIndex + 1 : undefined
    };
  });
};

export const getFilteredBrands = ({
  searchTerm,
  visibleBrands,
  localOrder,
  activeBrandsOrder,
  getBrandName
}: {
  searchTerm: string;
  visibleBrands: Set<number>;
  localOrder: number[];
  activeBrandsOrder: BrandOrder[];
  getBrandName: (id: number) => string;
}) => {
  const search = searchTerm.trim().toLowerCase();

  if (!search) {
    const selected = localOrder.filter(id => visibleBrands.has(id));
    const unselected = activeBrandsOrder.filter(brand => !visibleBrands.has(brand.id));

    return { selected, unselected };
  }

  const selected = localOrder.filter(id => visibleBrands.has(id) && getBrandName(id).toLowerCase().includes(search));

  const unselected = activeBrandsOrder.filter(
    brand => !visibleBrands.has(brand.id) && brand.name.toLowerCase().includes(search)
  );

  return { selected, unselected };
};
